module.exports = __webpack_public_path__ + "static/img/2.9c58182.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/2.jpg
// module id = c29v
// module chunks = 1